import { Box, Link, Table, TableBody, TableCell, TableRow, Typography } from '@mui/material'
import RichText from '@/src/components/common/RichText'

interface QuickFact {
    label: string
    value: string
}

interface DestinationInfoProps {
    heading: string
    overview: string
    quickFacts: QuickFact[]
    destinationUrl?: string | null
    seeMoreLabel: string
}

const DestinationInfo: React.FC<DestinationInfoProps> = ({ heading, overview, quickFacts, destinationUrl, seeMoreLabel }) => {
    return (
        <Box sx={{ mb: 3 }}>
            <Typography
                component="h2"
                variant="h6"
                sx={{ fontWeight: 600, fontSize: { xs: '1rem', md: '1.25rem' }, mb: 1.5 }}
            >
                {heading}
            </Typography>
            <RichText html={overview} variant="body1" sx={{ color: 'text.secondary', lineHeight: 1.8, mb: 2 }} />
            {quickFacts.length > 0 && (
                <Table size="small" sx={{ border: 1, borderColor: 'grey.200', borderRadius: 1, overflow: 'hidden' }}>
                    <TableBody>
                        {quickFacts.map((fact, i) => (
                            <TableRow key={i}>
                                <TableCell sx={{ fontWeight: 600, fontSize: '0.8125rem', borderColor: 'grey.200', width: '40%', py: 1.25 }}>
                                    {fact.label}
                                </TableCell>
                                <TableCell sx={{ fontSize: '0.8125rem', color: 'text.secondary', borderColor: 'grey.200', py: 1.25 }}>
                                    {fact.value}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            )}
            {destinationUrl && (
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1.5 }}>
                    <Link
                        href={destinationUrl}
                        underline="hover"
                        variant="body2"
                        sx={{ fontWeight: 500, color: 'primary.main', display: 'inline-flex', alignItems: 'center', gap: 0.5 }}
                    >
                        {seeMoreLabel}
                    </Link>
                </Box>
            )}
        </Box>
    )
}

export default DestinationInfo
export type { DestinationInfoProps }
